/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getAllStockSucursal } from '../../../Services/stockSucursalService'

const useModalStockEtiquetas = (sucursal, listaPrecio, modalId = 'modalArticuloEtiquetas') => {
    const isMountedRef = useRef(true)
    const [articulos, setArticulos] = useState([])
    const [isLoad, setIsLoad] = useState(true)
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const [searchCriteria, setSearchCriteria] = useState('nombre')
    const [isOpen, setIsOpen] = useState(false)
    const lastSearchRef = useRef('')

    const validateInput = (value, criteria) => {
        switch (criteria) {
            case 'nombre':
                return /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s\-.]*$/.test(value)
            case 'codigo':
                return /^\d*$/.test(value)
            case 'codigoBarra':
                return true
            default:
                return true
        }
    }

    const showValidationWarning = (criteria) => {
        let title = ''
        switch (criteria) {
            case 'nombre':
                title = 'Solo se permiten letras'
                break
            case 'codigo':
                title = 'Solo se permiten números'
                break
            default:
                return
        }
        Swal.fire({
            title: title,
            type: 'warning',
            showConfirmButton: false,
            timer: 2000,
            toast: true,
            position: 'top'
        })
    }

    const handleOpenModal = () => {
        lastSearchRef.current = ''
        setIsOpen(true)
    }

    const handleCloseModal = () => {
        setIsOpen(false)
    }

    const handleAnimationEnd = () => {
        if (!document.getElementById(modalId)?.classList.contains('show')) {
            setIsOpen(false)
        }
    }

    const getSearchParams = (searchTerm, criteria) => {
        const cleanTerm = searchTerm.trim()
        return {
            codigo: criteria === 'codigo' ? cleanTerm : '',
            nombre: criteria === 'nombre' ? cleanTerm : '',
            codigoBarra: criteria === 'codigoBarra' ? cleanTerm : ''
        }
    }

    const fetchArticles = async (searchTerm = '') => {
        if (!sucursal?.id) return
        setIsLoad(true)
        const { codigo, nombre, codigoBarra } = getSearchParams(searchTerm, searchCriteria)
        const listaId = listaPrecio?.id ?? null

        getAllStockSucursal(true, 0, sucursal.id, listaId, codigoBarra, codigo, nombre)
            .then((res) => {
                if (isMountedRef.current) {
                    setArticulos(res.data.content)
                    setTotalRegister(res.data.totalElements)
                    setTotalPage(res.data.totalPages)
                    setPage(0)
                    setIsLoad(false)
                }
            })
            .catch((error) => {
                if (isMountedRef.current) {
                    console.log(error.response)
                }
            })
    }

    useEffect(() => {
        if (isOpen && sucursal?.id) {
            fetchArticles()
        }
    }, [isOpen, sucursal?.id, listaPrecio?.id])

    useEffect(() => {
        return () => {
            isMountedRef.current = false
        }
    }, [])

    const onChangeArticulo = (e) => {
        const inputValue = e.target.value
        if (!validateInput(inputValue, searchCriteria)) {
            showValidationWarning(searchCriteria)
            return
        }
        setQuery(inputValue)
    }

    const handleSearchKeyPress = (e) => {
        if (e.key === 'Enter' && sucursal?.id) {
            e.preventDefault()
            const trimmedValue = query.trim()
            const listaId = listaPrecio?.id ?? null

            if (trimmedValue === '' && lastSearchRef.current !== '') {
                const { codigo, nombre, codigoBarra } = getSearchParams('', searchCriteria)
                getAllStockSucursal(true, 0, sucursal.id, listaId, codigoBarra, codigo, nombre)
                    .then((res) => {
                        if (isMountedRef.current) {
                            setPage(0)
                            setArticulos(res.data.content)
                            setTotalRegister(res.data.totalElements)
                            setTotalPage(res.data.totalPages)
                            setIsLoad(false)
                            lastSearchRef.current = ''
                        }
                    })
                    .catch((error) => {
                        if (isMountedRef.current) console.log(error.response)
                    })
            } else if (trimmedValue !== '' && trimmedValue !== lastSearchRef.current) {
                const { codigo, nombre, codigoBarra } = getSearchParams(trimmedValue, searchCriteria)
                getAllStockSucursal(true, 0, sucursal.id, listaId, codigoBarra, codigo, nombre)
                    .then((res) => {
                        if (isMountedRef.current) {
                            setPage(0)
                            setArticulos(res.data.content)
                            setTotalRegister(res.data.totalElements)
                            setTotalPage(res.data.totalPages)
                            setIsLoad(false)
                            lastSearchRef.current = trimmedValue
                        }
                    })
                    .catch((error) => {
                        if (isMountedRef.current) console.log(error.response)
                    })
            }
        }
    }

    const onChangeSearchCriteria = (e) => {
        setSearchCriteria(e.target.value)
        setQuery('')
        fetchArticles()
    }

    const nextPage = () => {
        if (!sucursal?.id) return
        if (totalPage === 0 || page >= totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        const { codigo, nombre, codigoBarra } = getSearchParams(query, searchCriteria)
        const listaId = listaPrecio?.id ?? null

        getAllStockSucursal(true, page + 1, sucursal.id, listaId, codigoBarra, codigo, nombre)
            .then((res) => {
                if (isMountedRef.current) {
                    setPage(page + 1)
                    setTotalPage(res.data.totalPages)
                    setTotalRegister(res.data.totalElements)
                    setArticulos(res.data.content)
                    setIsLoad(false)
                }
            })
            .catch((error) => {
                if (isMountedRef.current) console.log(error)
            })
    }

    const previousPage = () => {
        if (!sucursal?.id) return
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                type: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }
        const { codigo, nombre, codigoBarra } = getSearchParams(query, searchCriteria)
        const listaId = listaPrecio?.id ?? null

        getAllStockSucursal(true, page - 1, sucursal.id, listaId, codigoBarra, codigo, nombre)
            .then((res) => {
                if (isMountedRef.current) {
                    setPage(page - 1)
                    setTotalPage(res.data.totalPages)
                    setTotalRegister(res.data.totalElements)
                    setArticulos(res.data.content)
                    setIsLoad(false)
                }
            })
            .catch((error) => {
                if (isMountedRef.current) console.log(error)
            })
    }

    return {
        articulos,
        totalRegister,
        totalPage,
        page,
        nextPage,
        previousPage,
        onChangeArticulo,
        handleSearchKeyPress,
        onChangeSearchCriteria,
        searchCriteria,
        query,
        isLoad,
        handleOpenModal,
        handleCloseModal,
        handleAnimationEnd
    }
}

export default useModalStockEtiquetas
